import { render, staticRenderFns } from "./Withdrawscb.vue?vue&type=template&id=10ce6588&"
import script from "./Withdrawscb.vue?vue&type=script&lang=js&"
export * from "./Withdrawscb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports